import { Redirect } from "expo-router";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import type { UserRole } from "@chinese-vendor/schemas";

/**
 * Root redirect — dispatches to the correct starting screen
 * based on authentication state, role, and vendor status.
 */
export default function Index() {
  const { isAuthenticated, user, isPendingApplication } = useAuth();
  const { localeHydrated, hasStoredLocale } = useI18n();

  if (!isAuthenticated || !user) {
    if (!localeHydrated) return null;
    return <Redirect href={hasStoredLocale ? "/(auth)/login" : "/get-started"} />;
  }

  const isVendor = user.roles.includes("vendor");
  const isStaff = user.roles.some((r: UserRole) =>
    (["staff", "admin", "super_admin", "localization_staff"] as UserRole[]).includes(r)
  );

  if (isVendor) {
    return <Redirect href="/(vendor)/(dashboard)" />;
  }

  if (isStaff) {
    return <Redirect href="/(staff)/(dashboard)" />;
  }

  return (
    <Redirect
      href={
        hasStoredLocale
          ? "/(auth)/login"
          : isPendingApplication
            ? "/(auth)/register"
            : "/get-started"
      }
    />
  );
}
